import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TOAST_SEVERITY, ToastSeverity } from '../constants/toast';

export interface ToastState {
  message: string;
  severity: ToastSeverity;
}

interface ToastSliceState {
  current: ToastState | null;
}

const initialState: ToastSliceState = {
  current: null,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<{ message: string; severity?: ToastSeverity }>) => {
      state.current = {
        message: action.payload.message,
        severity: action.payload.severity ?? TOAST_SEVERITY.INFO,
      };
    },
    closeToast: (state) => {
      state.current = null;
    },
  },
});

export const toastActions = toastSlice.actions;
export const selectToast = (state: { toast: ToastSliceState }) => state.toast.current;

export default toastSlice.reducer;
